import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Routes} from '@angular/router';
import {AuthService} from '../services/auth/auth.service';
import {AuthGuard} from './auth.guard';
import {LoginComponent} from './login/login.component';
import {PersonalUserZkkSelectionComponent} from './personalUser/personal-user/personal-user-zkk-selection.component';
import {ZkkSelectionViewComponent} from './zkk-selection-view/zkk-selection-view.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [
      (next: ActivatedRouteSnapshot) => {
        inject(AuthService).login(next.queryParams.redirect ? decodeURIComponent(next.queryParams.redirect) : undefined);
        return false;
      }
    ]
  },
  {path: 'zkkSelection', component: ZkkSelectionViewComponent, canActivate: [AuthGuard]},
  {path: 'personalUserZkkSelection', component: PersonalUserZkkSelectionComponent, canActivate: [AuthGuard]}
];

// no separate routing module as auth module is loaded eagerly!
